<script>
import BidStrategyComboBox from './BidStrategyComboBox'
import BudgetTypeComboBox from './BudgetTypeComboBox'
import CurrencyField from './CurrencyField'

export default {
  name: 'BudgetForm',
  components: {
    BidStrategyComboBox,
    BudgetTypeComboBox,
    CurrencyField
  },
  props: {
    name: { type: String, required: false, default: 'Budget' },
    disabled: { type: Boolean, required: false, default: false },
    value: { type: Object, required: true }
  },
  computed: {
    enabled: {
      get() {
        return !this.$props.disabled && this.formData.enabled
      },
      set(value) {
        if (!this.$props.disabled) {
          this.update('enabled', !!value)
        }
      }
    }
  },
  data() {
    return {
      formData: this.value
    }
  },
  methods: {
    update(field, value) {
      this.formData[field] = value
      this.$emit('input', this.formData)
    }
  },
  watch: {
    value: function(oldValue, newValue) {
      this.formData = newValue
    }
  }
}
</script>

<template>
  <v-form>
    <v-checkbox v-model="enabled" :label="'Enable ' + name" />
    <bid-strategy-combo-box
      :disabled="!formData.enabled"
      :value="formData.bidStrategy"
      @input="update('bidStrategy', $event)"
    />
    <budget-type-combo-box :disabled="!formData.enabled" :value="formData.type" @input="update('type', $event)" />
    <currency-field
      label="Budget"
      placeholder="Budget"
      prefix="$"
      type="number"
      step="0.01"
      min="0"
      :value="formData.amount"
      @input="update('amount', $event)"
      :disabled="!formData.enabled"
    />
  </v-form>
</template>
